import { Component } from '@angular/core';

@Component({
  selector: 'cil-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {}
